import { isShoppingHost } from '@/config/appHosts';

export const appEnvironment = process.env.VUE_APP_ENV || process.env.VUE_APP_SERVER || 'local'

export function getServerEnvironment () {
  return process.env.VUE_APP_SERVER || appEnvironment
}

export function usesHostedBackend () {
  return ['NC160V3_PROD', 'NC160V4_INT'].includes(getServerEnvironment())
}

export function isWindowsDevelopment () {
  return getServerEnvironment() === 'Windows'
}

export function getEnvironmentLabel () {
  if (getServerEnvironment() === 'NC160V3_PROD') {
    return 'PROD Linux'
  }

  if (getServerEnvironment() === 'NC160V4_INT') {
    return 'INT Linux'
  }

  if (getServerEnvironment() === 'ubuntudev') {
    return 'DEV ubuntudev'
  }

  if (isWindowsDevelopment()) {
    return 'DEV Windows'
  }

  return appEnvironment
}

export function getApiBaseUrl () {
  // The Shopping vhost proxies /api/ to the existing backend (same-origin cookies).
  if (isShoppingHost()) return '/api/';
  if (process.env.VUE_APP_API_BASE_URL) {
    return process.env.VUE_APP_API_BASE_URL
  }

  return usesHostedBackend() ? '/' : '/api'
}

export function getApiBaseHint () {
  const baseUrl = getApiBaseUrl()
  return baseUrl === '/' ? '' : baseUrl
}
